const $ = require('jquery');
const _ = require('lodash');

require('./bootstrap');
require('bootstrap-datepicker');
require('with-global-jquery')(function () {
	require('bootstrap-datepicker/js/locales/bootstrap-datepicker.ru.js');
});

const template = require('../templates/datepicker.html');


Object.assign($.fn.datepicker.defaults, {
	language: "ru",
	autoclose: true,
	todayHighlight: true,
	// focus next input when after date is selected (true or selector string)
	focusNextInput: false,
});


const Datepicker = $.fn.datepicker.Constructor;
const Plugin = $.fn.datepicker;

const defaults = $.fn.datepicker.defaults;
const dates = $.fn.datepicker.dates;
const locale_opts = $.fn.datepicker.locale_opts;
const DPGlobal = $.fn.datepicker.DPGlobal;

$.fn.datepicker.savedDefaultProps = {
	Datepicker,
	Plugin,
	DPGlobal: $.extend({}, DPGlobal),
};

Object.assign(DPGlobal, {
	template: '<div class="datepicker rgs-datepicker"></div>', // 'datepicker.html' template is used as content
});

function UTCDate (){
	return new Date(Date.UTC(...arguments));
}

function ExtendedDatepicker () {
	Datepicker.apply(this, arguments);
	this.constructor = ExtendedDatepicker;
	return this;
}

ExtendedDatepicker.prototype = $.extend({}, Datepicker.prototype, {
	template: template,
	showMode: function () {
		this.viewMode = 0; // always "days" mode
		this.updateNavArrows();
	},
	fillDow: _.noop,
	fillMonths: _.noop,
	fill: function () { // Partially adopted from bootstrap-datepicker with some refactoring
		this.checkViewDateBoundaries();

		const locale = dates[this.o.language];
		let d = new Date(this.viewDate),
			year = d.getUTCFullYear(),
			month = d.getUTCMonth(),
			startYear = this.o.startDate !== -Infinity
				? this.o.startDate.getUTCFullYear()
				: -Infinity,
			startMonth = this.o.startDate !== -Infinity
				? this.o.startDate.getUTCMonth()
				: -Infinity,
			endYear = this.o.endDate !== Infinity ? this.o.endDate.getUTCFullYear() : Infinity,
			endMonth = this.o.endDate !== Infinity ? this.o.endDate.getUTCMonth() : Infinity;

		if (isNaN(year) || isNaN(month)) {
			return;
		}

		const data = {};

		function classObjToList (obj) {
			return _.keys(_.pickBy(obj, Boolean));
		}

		data.months = _.map(_.range(12), (m) => {
			const timestamp = new Date(d);
			timestamp.setUTCMonth(m);

			const classList = classObjToList({
				'datepicker-month': true,
				'active': m === month,
				'disabled': (year < startYear || year > endYear)
					|| (year === startYear && m < startMonth)
					|| (year === endYear && m > endMonth),
			});

			return {
				name: locale.months[m],
				nameShort: locale.monthsShort[m],
				classList: classList,
				timestamp: timestamp.getTime(),
			};
		});

		data.year = {
			name: year,
			timestamp: d.getTime(),
			classList: classObjToList({
				'datepicker-year': true,
				'datepicker-year-add': true,
				'datepicker-year-reduce': true,
				'disabled': startYear === endYear && year === startYear,
			}),
		};

		data.dow = _.map(_.range(this.o.weekStart, this.o.weekStart + 7), function (n) {
			return {
				nameMin: locale.daysMin[n % 7],
			};
		});

		data.weeks = (function () {
			let prevMonth = UTCDate(year, month - 1, 28),
				day = DPGlobal.getDaysInMonth(prevMonth.getUTCFullYear(), prevMonth.getUTCMonth());
			prevMonth.setUTCDate(day);
			prevMonth.setUTCDate(day - (prevMonth.getUTCDay() - this.o.weekStart + 7) % 7);
			let nextMonth = new Date(prevMonth);
			if (prevMonth.getUTCFullYear() < 100){
				nextMonth.setUTCFullYear(prevMonth.getUTCFullYear());
			}
			nextMonth.setUTCDate(nextMonth.getUTCDate() + 42);
			nextMonth = nextMonth.valueOf();

			let weeks = [];
			let week;

			while (prevMonth.valueOf() < nextMonth){
				if (prevMonth.getUTCDay() === this.o.weekStart){
					week = [];
					weeks.push(week);
				}
				let classList = this.getClassNames(prevMonth);
				classList.push('datepicker-day');

				if (this.o.beforeShowDay !== $.noop){
					let before = this.o.beforeShowDay(this._utc_to_local(prevMonth));
					if (before === undefined) {
						before = {};
					} else if (typeof (before) === 'boolean') {
						before = {enabled: before};
					} else if (typeof (before) === 'string') {
						before = {classes: before};
					}
					if (before.enabled === false) {
						classList.push('disabled');
					}
					if (before.classes) {
						classList = classList.concat(before.classes.split(/\s+/));
					}
				}

				classList = $.unique(classList);

				week.push({
					classList: classList,
					number: prevMonth.getUTCDate(),
					timestamp: prevMonth.getTime(),
				});

				prevMonth.setUTCDate(prevMonth.getUTCDate() + 1);
			}

			weeks = _.filter(weeks, function (week) {
				return _.some(week, function (day) {
					return !_.includes(day.classList, 'old')
						&& !_.includes(day.classList, 'new');
				});
			});

			return weeks;
		}).call(this);

		this.picker.html(this.template(data));
	},
	updateNavArrows: _.noop,
	click: function (e) {
		e.preventDefault();
		e.stopPropagation();
		const $target = $(e.target).closest('a, td, th');

		if ($target.is('.disabled')) {
			return;
		}

		const classList = ($target.attr('class') || '').split(/\s+/g);

		const targetClass = _.find(classList, function (cls) {
			return /^datepicker-/.test(cls);
		});

		const handler = {
			'datepicker-year-reduce': this.clickReduceYear,
			'datepicker-year-add': this.clickAddYear,
			'datepicker-month': this.clickMonth,
			'datepicker-day': this.clickDay,
		}[targetClass] || $.noop;

		handler.call(this, e, $target);
	},
	checkViewDateBoundaries: function () {
		if (this.viewDate < this.o.startDate) {
			this.viewDate = new Date(this.o.startDate);
		} else if (this.viewDate > this.o.endDate) {
			this.viewDate = new Date(this.o.endDate);
		}
	},
	clickAddYear: function () {
		let d = new Date(this.viewDate),
			year = d.getUTCFullYear(),
			endYear = this.o.endDate !== Infinity
				? this.o.endDate.getUTCFullYear()
				: Infinity;

		if (year === endYear){
			return;
		}

		year++;
		this.viewDate.setUTCMonth(0);
		this.viewDate.setUTCFullYear(year);
		this._trigger('changeYear', this.viewDate);
		this.fill();
	},
	clickReduceYear: function () {
		let d = new Date(this.viewDate),
			year = d.getUTCFullYear(),
			startYear = this.o.startDate !== -Infinity
				? this.o.startDate.getUTCFullYear()
				: -Infinity;

		if (year === startYear){
			return;
		}

		year--;
		this.viewDate.setUTCMonth(0);
		this.viewDate.setUTCFullYear(year);
		this._trigger('changeYear', this.viewDate);
		this.fill();
	},
	clickMonth: function (e, $target) {
		const d = UTCDate();
		d.setTime($target.data('datepickerTimestamp'));

		const month = d.getUTCMonth();

		this.viewDate.setUTCDate(1);
		this.viewDate.setUTCMonth(month);
		this._trigger('changeMonth', this.viewDate);
		this.fill();
	},
	clickDay: function (e, $target) {
		const d = UTCDate();
		d.setTime($target.data('datepickerTimestamp'));

		const day = d.getUTCDate();
		const month = d.getUTCMonth();
		const year = d.getUTCFullYear();

		this._setDate(UTCDate(year, month, day));

		this._focusNextInput();
	},
	_focusNextInput: function () {
		if (!this.o.focusNextInput) {
			return;
		}

		let $nextInput;

		if (_.isString(this.o.focusNextInput)) {
			$nextInput = $(this.o.focusNextInput);
		} else {
			$nextInput = this.element.next('input');
		}

		$nextInput.focus();
	},
});


function opts_from_el (el, prefix){
	// Derive options from element data-attrs
	let data = $(el).data(),
		out = {}, inkey,
		replace = new RegExp('^' + prefix.toLowerCase() + '([A-Z])');
	prefix = new RegExp('^' + prefix.toLowerCase());
	function re_lower (_, a){
		return a.toLowerCase();
	}
	for (const key in data) {
		if (prefix.test(key)){
			inkey = key.replace(replace, re_lower);
			out[inkey] = data[key];
		}
	}
	return out;
}

function opts_from_locale (lang){
	// Derive options from locale plugins
	const out = {};
	// Check if "de-DE" style date is available, if not language should
	// fallback to 2 letter code eg "de"
	if (!dates[lang]){
		lang = lang.split('-')[0];
		if (!dates[lang]) {
			return;
		}
	}
	const d = dates[lang];
	$.each(locale_opts, function (i, k){
		if (k in d) {
			out[k] = d[k];
		}
	});
	return out;
}

function ExtendedPlugin (option) {
	const args = Array(...arguments);
	args.shift();
	let internal_return;
	this.each(function (){
		let $this = $(this),
			data = $this.data('datepicker'),
			options = typeof option === 'object' && option;
		if (!data){
			let elopts = opts_from_el(this, 'date'),
			// Preliminary otions
				xopts = $.extend({}, defaults, elopts, options),
				locopts = opts_from_locale(xopts.language),
			// Options priority: js args, data-attrs, locales, defaults
				opts = $.extend({}, defaults, locopts, elopts, options);
			if ($this.hasClass('input-daterange') || opts.inputs){
				$.extend(opts, {
					inputs: opts.inputs || $this.find('input').toArray(),
				});
				// data = new DateRangePicker(this, opts); // TODO?
				throw new Error('ExtendedDateRangePicker not implemented');
			}			else {
				data = new ExtendedDatepicker(this, opts);
			}
			$this.data('datepicker', data);
		}
		if (typeof option === 'string' && typeof data[option] === 'function'){
			internal_return = data[option](...args);
		}
	});

	if (
		internal_return === undefined
			|| internal_return instanceof Datepicker
			// || internal_return instanceof DateRangePicker // TODO?
	) {
		return this;
	}

	if (this.length > 1) {
		throw new Error('Using only allowed for the collection'
						+ ' of a single element (' + option + ' function)');
	} else {
		return internal_return;
	}
}


$.extend(ExtendedPlugin, Plugin);
$.fn.datepicker = ExtendedPlugin;
$.fn.tooltip.Constructor = ExtendedDatepicker;


module.exports = $.fn.datepicker;
